import { render } from "./ScreenSettings.vue?vue&type=template&id=24f042ae&scoped=true&ts=true&lang=pug"
import script from "./ScreenSettings.vue?vue&type=script&lang=ts"
export * from "./ScreenSettings.vue?vue&type=script&lang=ts"

import "./ScreenSettings.vue?vue&type=style&index=0&id=24f042ae&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f042ae"]])

export default __exports__